import { getReferralLink } from '@/server/rebate'
import registeredAddress from '@/utils/registered_address'

let refreshingPromise = null

export function refreshReferralLinks() {
  if (refreshingPromise) return refreshingPromise

  refreshingPromise = getReferralLink(true)
    .then(result => {
      if (result && result.success && Array.isArray(result.data)) {
        registeredAddress.setExchangeLinks(result.data)
        return true
      }

      registeredAddress.resetExchangeLinks()
      return false
    })
    .catch(() => {
      registeredAddress.resetExchangeLinks()
      return false
    })
    .finally(() => {
      refreshingPromise = null
    })

  return refreshingPromise
}
